import tw from 'twin.macro';

export default tw.section`px-8 lg:px-0 h-auto min-h-hero xl:h-hero text-center py-8 lg:py-32 flex flex-col`;
